/**
 * Representa os dados extraídos de um token JWT de autenticação
 */
export class ParsedToken {
  /** Data de expiração do token (timestamp Unix) */
  readonly exp: number;

  /** Data de emissão do token (timestamp Unix) */
  readonly iat: number;

  /** Último momento em que a autenticação foi realizada (timestamp Unix) */
  readonly auth_time: number;

  /** ID único do token (JWT ID) */
  readonly jti: string;

  /** URL do emissor do token (servidor de autenticação) */
  readonly iss: string;

  /** Destinatários para os quais o token foi emitido */
  readonly aud: string[];

  /** ID do usuário (subject) */
  readonly sub: string;

  /** Tipo do token */
  readonly typ: string;

  /** Cliente autorizado que solicitou o token */
  readonly azp: string;

  /** ID da sessão */
  readonly sid: string;

  /** Nível de contexto de autenticação */
  readonly acr: string;

  /** Origens permitidas para uso do token (CORS) */
  readonly allowedOrigins: string[];

  /** Escopos de acesso concedidos */
  readonly scope: string;

  /** Indica se o email do usuário foi verificado */
  readonly emailVerified: boolean;

  /** Data de criação do usuário (timestamp Unix em milissegundos) */
  readonly createdDate: string;

  /** Funções/permissões atribuídas ao usuário */
  readonly roles: string[];

  /** Nome completo do usuário */
  readonly name: string;

  /** IDs de inquilinos/organizações aos quais o usuário tem acesso */
  readonly tenantId: string[];

  /** Grupos aos quais o usuário pertence */
  readonly groups: string[];

  /** Nome de usuário preferido (geralmente CPF ou outro identificador único) */
  readonly preferredUsername: string;

  /** Primeiro nome do usuário */
  readonly givenName: string;

  /** Sobrenome do usuário */
  readonly familyName: string;

  /** Email do usuário */
  readonly email: string;

  constructor(tokenData: any) {
    const data = tokenData || {};
    this.exp = data.exp;
    this.iat = data.iat;
    this.auth_time = data.auth_time;
    this.jti = data.jti;
    this.iss = data.iss;
    this.aud = data.aud;
    this.sub = data.sub;
    this.typ = data.typ;
    this.azp = data.azp;
    this.sid = data.sid;
    this.acr = data.acr;
    this.allowedOrigins = data['allowed-origins'];
    this.scope = data.scope;
    this.emailVerified = data.email_verified;
    this.createdDate = data.createdDate;
    this.roles = data.roles;
    this.name = data.name;
    this.tenantId = data.tenantId;
    this.groups = data.groups;
    this.preferredUsername = data.preferred_username;
    this.givenName = data.given_name;
    this.familyName = data.family_name;
    this.email = data.email;
  }
}
